module.exports = __webpack_public_path__ + "img/190.2fc4a6b6.jpg";